import React from 'react';
import { formatUSDT } from '../../utils/format';

const AdminStats = ({ stats }) => {
  return (
    <div className="grid grid-4" style={{ marginBottom: 24 }}>
      <div className="stat-card">
        <div className="stat-label">Total Users</div>
        <div className="stat-value stat-value-sm">{stats.totalUsers?.toString() || '0'}</div>
      </div>
      <div className="stat-card green">
        <div className="stat-label">Active Users</div>
        <div className="stat-value stat-value-sm">{stats.activeCount?.toString() || '0'}</div>
      </div>
      <div className="stat-card purple">
        <div className="stat-label">Total Invested</div>
        <div className="stat-value stat-value-sm">
          {formatUSDT(stats.totalInvestmentAmount || '0')}<span className="stat-suffix">USDT</span>
        </div>
      </div>
      <div className="stat-card pink">
        <div className="stat-label">Blacklisted</div>
        <div className="stat-value stat-value-sm">{stats.blacklistedCount?.toString() || '0'}</div>
      </div>
      <div className="stat-card">
        <div className="stat-label">Contract Balance</div>
        <div className="stat-value stat-value-sm">
          {formatUSDT(stats.contractBalance || '0')}<span className="stat-suffix">USDT</span>
        </div>
      </div>
    </div>
  );
};

export default AdminStats;
